module.exports = __webpack_public_path__ + "static/media/info-full-width.f80a8f8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/industry/info-full-width.png
// module id = 792
// module chunks = 0